<!-- introduction Section -->
<section id="introduction" class="content-section">
    <div class="row" appDynamicDirection>
      <div class="container">
        <div class="col-lg-12">
            <h2 class="heading" i18n>Introduction</h2>
            <p i18n>The Sustainable Development Goal 6 Policy Support System (SDG-PSS) was developed by the United Nations University Institute for Water, Environment and Health (UNU-INWEH), the United Nations Office for Sustainable Development (UNOSD), the Ministry of Environment, Republic of Korea (MOE), the Korea Environment Corporation (K-eco) and national partners from Costa Rica, Pakistan, and Tunisia as part of the project
            <strong style="color:#58aec9;">‘Water in the World We Want’.</strong></p>
            <!-- <ul i18n>
              <li>Instituto Costarricense de Acueductos y Alcantarillados (AyA), Costa Rica</li>
              <li>Ministerio de Ambiente y Energía (MINAE), Costa Rica</li>
              <li>National Development Planning Commission (NDPC), Ghana</li>
              <li>Water Research Institute (WRI), Ghana</li>
              <li>Pakistan Council of Research in Water Resources (PCRWR), Pakistan</li>
              <li>Ministry of Planning, Development and Reforms, Pakistan</li>
              <li>National Research Institute for Rural Engineering, Water, and Forestry (INRGREF),
Tunisia</li>
              <li>Bureau de Planification et des Équilibres Hydrauliques (BPEH), Ministère de
l'Agriculture</li>
              <li>Ressources Hydrauliques et de la Pêche (MARHP), Tunisia</li>
            </ul> -->
            <br>
            <p i18n>The SDG-PSS was created to investigate options to support decision and policymaking on the enabling environments of SDG 6. This tool was designed to help navigate limited-data conditions while providing a collaborative platform to its users – allowing them to exchange knowledge, promote evidence-based solutions and contribute to achieving SDG 6. It was planned to enable water experts and researchers to create one national-level evidence base for SDG 6.              </p>
            <!-- <p i18n>For more information and description of the SDG-PSS, please go to the​
            <a href="{{src_pdf}}" download><strong> User Guide</strong></a></p><br> -->
            <br>
          <p i18n>Click <strong style="color:#58aec9;">‘Next’</strong> to continue to the overview page with general information about SDG-PSS or click
            <strong style="color:#58aec9;">‘Home’</strong> to navigate directly through different components of SDG-PSS.</p>
        </div>
        <div class="col-lg-12" style="margin-top: 20px;">
            <a class="btn-lg btn btn-primary btn-radius" style="margin: 15px 0; min-width: 150px" routerLink="/home" i18n>Home</a>
            <a class="btn-lg btn btn-info btn-radius" style="margin: 15px 0; min-width: 150px;" routerLink="/introduction/overview" i18n>Next</a>
        </div>
      </div>
    </div>
</section>



// WEBPACK FOOTER //
// ./src/app/introduction/intro-home/intro-home.component.html